import React from 'react';
export function PersonalStory() {
  return <section className="mb-16" data-id="element-320">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-6 leading-tight font-['Playfair_Display']" data-id="element-321">
        "It Started With a Complaint From My Wife"
      </h2>
      <div className="flex flex-col md:flex-row gap-6" data-id="element-322">
        <div className="md:w-3/5" data-id="element-323">
          <p className="text-lg text-[#2C3E50] mb-4 font-['Inter']" data-id="element-324">
            Two years ago, my wife Trisha had been religiously taking our Skin:
            Youthful collagen for 3 months. One evening, she sat me down:
          </p>
          <blockquote className="border-l-4 border-[#FFB88C] pl-4 italic text-lg text-[#2C3E50] mb-6 font-['Inter']" data-id="element-325">
            "Nihaal, I love that you created this for me. But honestly? After 90
            days, the results are... okay. Just okay. Can't you make something
            that works faster?"
          </blockquote>
          <p className="text-lg text-[#2C3E50] mb-8 font-['Inter']" data-id="element-326">
            That stung. Here I was, running one of India's leading nutraceutical
            companies, and I couldn't even impress my own wife.
          </p>
        </div>
        <div className="md:w-2/5" data-id="element-327">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rZuM7xLDoq7afZ8QfVddTM/u8357357769_Indian_entrepreneur_sitting_at_home_desk_late_at__4b7e3179-c3cc-4519-bf0e-cf0b8e3502d5_0.png" alt="Nihaal working late at night to improve the collagen formula" className="w-full h-auto rounded-lg shadow-md" data-id="element-328" />
        </div>
      </div>
      <div className="bg-white p-8 rounded-lg border border-[#7F8C8D]/20 shadow-sm hover:shadow-md transition-all duration-300 mb-8" data-id="element-329">
        <h3 className="text-lg font-medium text-[#1B2951] mb-4 font-['Poppins']" data-id="element-330">
          What our customers were saying:
        </h3>
        <div className="space-y-4" data-id="element-331">
          <div className="flex items-start" data-id="element-332">
            <div className="mr-2 text-[#FFB88C]" data-id="element-333">⭐⭐⭐</div>
            <p className="text-[#2C3E50] font-['Inter']" data-id="element-334">
              "Good product, but takes forever to show results"
            </p>
          </div>
          <div className="flex items-start" data-id="element-335">
            <div className="mr-2 text-[#FFB88C]" data-id="element-336">⭐⭐⭐</div>
            <p className="text-[#2C3E50] font-['Inter']" data-id="element-337">
              "3 months is too long to wait"
            </p>
          </div>
          <div className="flex items-start" data-id="element-338">
            <div className="mr-2 text-[#FFB88C]" data-id="element-339">⭐⭐⭐⭐</div>
            <p className="text-[#2C3E50] font-['Inter']" data-id="element-340">
              "Wish it worked faster"
            </p>
          </div>
        </div>
      </div>
    </section>;
}